import * as React from "react"
import "./_modal.scss"

import LoadingFrame from "§/src/components/atoms/loading-frame"

const Modal = React.forwardRef(({ modalid, children, footer, className, type, ...atomProps }, ref) => {

  const dismissModal = () => {
    document.querySelector(`#${modalid} .btn-close`)?.click();
  }
  const modalClasses = type === 'video' ? 'video-modal modal-xl modal-dialog-centered ' : 'modal-fullscreen modal-dialog-scrollable'

  React.useImperativeHandle(ref, () => ({
    dismissModal,
  }));

  return (
    <div
      key={modalid}
      className={className ? className + " modal fade pt-0" : "modal fade pt-0"}
      id={modalid}
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modalLabel"
      aria-hidden="true"
      atom="modal"
    >
      <div
        className="modal-dialog modal-fullscreen modal-dialog-scrollable"

        className={modalClasses + " modal-dialog"}
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <div> </div>
            <div className="close-button position-relative">
              <button
                type="button"
                className="btn-close m-0"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
          </div>
          <div className="modal-body pb-md-7">
            <div className="container-fluid">{children}</div>
            <LoadingFrame/>
          </div>
          {footer && <div className="modal-footer">{footer}</div>}
        </div>
      </div>
    </div>
  )
})

export default Modal
